import { RoutingPaths } from 'app/routes/routes'

import { isContractStatus } from 'entities/tour/libs/is-contract-status'

import type { TourDocumentStatus } from 'shared/api/tours/document-data'

export const getTourDocumentPath = (
  documentId: string,
  status: TourDocumentStatus | string,
) =>
  isContractStatus(status)
    ? RoutingPaths.tours.contract.path(documentId)
    : RoutingPaths.tours.documentDetails.path(documentId)
